export default function React_HOC() {
  return (
    <div>
      <h1>React_HOC Component</h1>
      <p>This is the React_HOC tutorial page.</p>
    </div>
  );
}
